import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { useForm } from "react-hook-form"; // Import useForm from react-hook-form

import { GetRequest, PatchRequest } from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";

import {
  ConfImageUploadService,
  flattenObject,
  ImageDataModalRequired,
  transformObject,
} from "./constants";
// import TextArea from "./Components/TextArea";
import MultipleImage from "./Components/MultipleImage";

const About = () => {
  const route = all_routes;
  const [banner, setBanner] = useState([]);
  const [about, setAbout] = useState([]);

  // const [Res, setRes] = useState("");
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    // control,
    formState: { isSubmitting },
  } = useForm();

  const fetchData = async () => {
    const res = await GetRequest(`${ApiUrl.configuration}${ConfUrl.about}`);
    if (res) {
      setBanner([res?.value?.banner]);
      setAbout([res?.value?.about]);
      const val = flattenObject(res?.value, "", ["banner", "about"]);
      Object.keys(val).forEach((key) => {
        setValue(key, val[key]);
      });

      setValue("confId", res.id);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    let Req = transformObject(data);

    if (banner?.length > 0) {
      let imgKey = null;
      if (banner[0]?.image instanceof File) {
        imgKey = await ConfImageUploadService(banner[0]?.image);
      }
      Req.banner = {
        key: banner[0]?.key,
        image: imgKey ? imgKey : banner[0]?.image,
        heading: banner[0]?.heading,
        subHeading: banner[0]?.subHeading,
      };
    }
    if (about?.length > 0) {
      let imgKey = null;
      if (about[0]?.image instanceof File) {
        imgKey = await ConfImageUploadService(about[0]?.image);
      }
      Req.about = {
        key: about[0]?.key,
        image: imgKey ? imgKey : about[0]?.image,
        heading: about[0]?.heading,
        subHeading: about[0]?.subHeading,
      };
    }

    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.about}`,
      Req
    );
    if (resp) {
      navigate(route.jobapplication);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>About Page</h4>
              {/* <h6>Create new Career</h6> */}
            </div>
          </div>
        </div>
        {/* /add */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="row">
                <h4>
                  <u>Banner</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="banner"
                    dataSource={banner}
                    setDataSource={setBanner}
                    DataRequired={[
                      ImageDataModalRequired.image,
                      ImageDataModalRequired.heading,
                      ImageDataModalRequired.description,
                    ]}
                    DataLimit={1}
                  />
                </div>
                <h4>
                  <u>About Us</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="about"
                    dataSource={about}
                    setDataSource={setAbout}
                    DataRequired={[
                      ImageDataModalRequired.image,
                      ImageDataModalRequired.heading,
                      ImageDataModalRequired.description,
                    ]}
                    DataLimit={1}
                  />
                </div>

                <h4>
                  <u>Why Us</u>
                </h4>
                {[
                  "excellence",
                  "quality",
                  "experience",
                  "integrity",
                  "collaboration",
                  "customerFocus",
                ].map((it) => (
                  <div className="col-12" key={it}>
                    <div className="mb-3 add-product">
                      <label className="form-label">{it}</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register(`whyUs_${it}`, {
                          required: `${it.toLocaleUpperCase()} is required`,
                        })}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-submit"
                // disabled={isSubmitting}
                // onClick={() => console.log("trapped")}
              >
                {isSubmitting ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </form>
        {/* /add */}
      </div>
    </div>
  );
};

export default About;
